import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AppHero = ({ title, subtitle, description, icon, backLink = "/", showBetaButton = false, showComingSoon = false, showStoreButtons = false, storeUrls = null, storeVisibility = null }) => {
  const scrollToTestFlight = () => {
    const testFlightSection = document.querySelector('.app-testflight');
    if (testFlightSection) {
      testFlightSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="app-hero">
      <div className="container">
        <div className="app-hero-content">
          <div className="app-hero-text">
            <h1 className="app-hero-title">{title}</h1>
            <p className="app-hero-subtitle">{subtitle}</p>
            <p className="app-hero-description">{description}</p>
            <div className="app-hero-buttons">
              {showStoreButtons && storeUrls ? (
                <>
                  {storeVisibility?.ios && (
                    <a href={storeUrls.ios} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                      <i className="fab fa-apple"></i>
                      &nbsp;Download on App Store
                    </a>
                  )}
                  {storeVisibility?.android && (
                    <a href={storeUrls.android} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                      <i className="fab fa-google-play"></i>
                      &nbsp;Get it on Google Play
                    </a>
                  )}
                </>
              ) : showBetaButton ? (
                <button onClick={scrollToTestFlight} className="btn btn-primary">
                  <i className="fab fa-apple"></i>
                   Join Beta
                </button>
              ) : showComingSoon ? (
                <button disabled className="btn btn-secondary">
                  <i className="fas fa-clock"></i>
                  Beta Coming Soon
                </button>
              ) : (
                <Link to={backLink} className="btn btn-primary">Back to Portfolio</Link>
              )}
            </div>
          </div>
          <div className="app-hero-image">
            <div className="app-hero-placeholder">
              <i className={icon}></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

AppHero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  backLink: PropTypes.string,
  showBetaButton: PropTypes.bool,
  showComingSoon: PropTypes.bool,
  showStoreButtons: PropTypes.bool,
  storeUrls: PropTypes.shape({
    ios: PropTypes.string,
    android: PropTypes.string
  }),
  storeVisibility: PropTypes.shape({
    ios: PropTypes.bool,
    android: PropTypes.bool
  })
};

AppHero.defaultProps = {
  backLink: "/",
  showBetaButton: false,
  showComingSoon: false,
  showStoreButtons: false
};

export default AppHero;
